<template>
    <div class="c-equivalence">
        <div class="c-equivalence__search">
            <div class="c-equivalence__search__inner">
                <h2 class="o-title-4 c-equivalence__search__title">
                    {{ t('Rechercher par :') }}
                </h2>
                <div class="o-form c-equivalence__search__form">
                    <div class="o-form-row">
                        <div class="o-form__item">
                            <div class="o-radio__wrap">
                                <input class="o-radio" type="radio" id="externe" v-model="selectedTypeFilter"
                                    value="externe" checked>
                                <label class="o-radio-label" for="externe">
                                    {{ t("Cours suivi et réussi dans une institution externe") }}
                                </label>
                            </div>
                        </div>
                        <div class="o-form__item">
                            <div class="o-radio__wrap">
                                <input class="o-radio" type="radio" id="interne" v-model="selectedTypeFilter"
                                    value="interne">
                                <label class="o-radio-label" for="interne"
                                    v-html="t('Cours suivi et réussi à l\'École de technologie supérieure')">
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="c-equivalence__search__form__items">
                        <div id="institution-externe" class="o-form-row">
                            <div class="o-form__item w-fill" v-if="selectedTypeFilter == 'externe'">
                                <label class="o-label c-equivalence__search__form__label" for="institution"
                                    v-html="t('Nom de l\'institution *')">
                                </label>
                                <div class="o-select__wrap">
                                    <select class="o-select c-equivalence__search__form__select" id="institution"
                                        v-model="selectedInstitution" required>
                                        <option :value="null" disabled selected>{{ t("Veuillez choisir une institution") }}
                                        </option>
                                        <option v-for="institution in institutionOptions" :value="institution.value"
                                            v-html="institution.label"></option>
                                    </select>
                                    <svg class="o-ico -ico-arrow-down" role="img">
                                        <title>arrow-down</title>
                                        <use
                                            :xlink:href="'/assets/img/sprite.svg?v=' + resourceVersion + '#arrow-down'">
                                        </use>
                                    </svg>

                                </div>
                            </div>
                            <div class="o-form__item w-200">
                                <label v-if="selectedTypeFilter == 'externe'"
                                    class="o-label c-equivalence__search__form__label" for="sigle-ou-code">
                                    {{ t("Sigle ou code du cours") }}
                                </label>
                                <label v-else class="o-label c-equivalence__search__form__label" for="sigle-ou-code">
                                    {{ t("Sigle du cours") }}
                                </label>
                                <input class="o-input c-equivalence__search__form__input" type="text" id="sigle-ou-code"
                                    v-model="selectedSigle" placeholder="">
                            </div>
                            <div class="o-form__item w-fill">
                                <label class="o-label c-equivalence__search__form__label" for="nom-externe">
                                    {{ t("Nom du cours") }}
                                </label>
                                <input class="o-input c-equivalence__search__form__input" type="text" id="nom-externe"
                                    v-model="selectedName" placeholder="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-equivalence__results" v-if="showResultatSum()">
            <div class="c-equivalence__results__count">
                {{ countFilteredEquivalence }} {{ t('résultats') }}
            </div>
            <button @click.prevent="resetFilters()" class="o-button -button-reset">
                {{ t('Réinitialiser la recherche') }}
            </button>
        </div>
        <table class="o-table o-table-responsive -bordered c-equivalence__table">
            <template v-for="(institution, index) in filteredEquivalences">
                <thead>
                    <tr>
                        <th colspan="2" v-if="selectedTypeFilter === 'interne'">
                            <span>{{ t('Cours suivi et réussi - École de technologie supérieure') }}</span>
                        </th>
                        <th colspan="2" v-else>
                            <span>{{ institution.name }}</span>
                        </th>
                        <th colspan="2">
                            <span>{{ t('Cours demandé pour une reconnaissance - École de technologie supérieure') }}</span>
                        </th>
                        <th>
                            <span>{{ t('Statut') }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(equivalence, idxe) in institution.equivalences" :key="idxe">
                        <tr>
                            <td :data-label="equivalence.sigle">
                                <span>{{ equivalence.sigle }}</span>
                            </td>
                            <td>
                                <span>{{ equivalence.titre }} </span>
                            </td>
                            <td :data-label="equivalence.sigleEts">
                                <span>{{ equivalence.sigleEts }}</span>
                            </td>
                            <td>
                                <span>{{ equivalence.titreEts }}</span>
                            </td>
                            <td data-label="Status">
                                <span>
                                    <svg class="o-ico -ico-approved" :class="'-ico-' + equivalence.status" role="img">
                                        <title>equivalence.status</title>
                                        <use
                                            :xlink:href="'/assets/img/sprite.svg?v=' + resourceVersion + '#' + equivalence.status">
                                        </use>
                                    </svg>
                                    <span v-if="equivalence.status === 'approved'">
                                        {{ t('Équivalence probable') }}
                                        <!-- {{ (equivalence.message !== null) ? '&nbsp;*': '' }} -->
                                        <span class="-table-icon" v-if="equivalence.message !== null"
                                            :class="(equivalence.message && toggleDetails === index + '-' + idxe) ? 'is-open' : ''">
                                        </span>
                                    </span>
                                    <span v-else-if="equivalence.status === 'not-approved'">
                                        {{ t('Non équivalent') }}
                                        <!-- {{ (equivalence.message !== null && equivalence.message != '') ? '&nbsp;*' :'' }} -->
                                        <span class="-table-icon" v-if="equivalence.message !== null"
                                            :class="(equivalence.message && toggleDetails === index + '-' + idxe) ? 'is-open' : ''"> {{}}
                                        </span>
                                    </span>
                                    <span v-else-if="equivalence.status === 'exception'">
                                        {{ t('À valider') }}
                                        <!-- {{ (equivalence.message !== null) ? '&nbsp;*' : '' }} -->
                                        <span class="-table-icon" v-if="equivalence.message !== null"
                                            :class="(equivalence.message && toggleDetails === index + '-' + idxe) ? 'is-open' : ''">
                                        </span>
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </template>
        </table>
    </div>
</template>

<script>
export default {
    name: 'Equivalence',
    components: {
        // Import your components here
    },
    data() {
        return {
            selectedTypeFilter: 'externe',
            selectedInstitution: null,
            selectedSigle: '',
            selectedName: '',
            toggleDetails: null,
            equivalences: Equivalences
        };
    },
    mounted() {
        // Fetch data or perform any setup here
    },
    watch: {
        selectedTypeFilter(newValue) {
            if (newValue !== 'externe') {
                this.selectedInstitution = '';
            }
        }
    },
    computed: {
        resourceVersion() {
            return window.resourceVersion;
        },
        filteredEquivalences() {
            // if not filtered, return []
            if (!this.selectedInstitution && !this.selectedSigle && !this.selectedName) {
                return [];
            }
            let equivalences = this.equivalences.filter(equivalence => {
                let matches = true;
                let sigleField = this.selectedTypeFilter === 'externe' ? 'sigle' : 'sigleEts';
                let nameField = this.selectedTypeFilter === 'externe' ? 'titre' : 'titreEts';

                if (equivalence.institutionIsInternal && this.selectedTypeFilter === 'externe') {
                    return false;
                }

                if (!equivalence.institutionIsInternal && this.selectedTypeFilter === 'interne') {
                    return false;
                }

                if (this.selectedInstitution) {
                    matches = matches && equivalence.institutionId === this.selectedInstitution;
                }

                if (this.selectedTypeFilter === 'externe') {
                    matches = matches && !equivalence.institutionIsInternal;
                } else {
                    matches = matches && equivalence.institutionIsInternal;
                }

                // fuzzy search
                if (this.selectedSigle) {
                    if (this.selectedTypeFilter === 'externe') {
                        matches = matches && equivalence.sigle.toLowerCase().includes(this.selectedSigle.toLowerCase());
                    } else {
                        matches = matches && (equivalence.sigleEts.toLowerCase().includes(this.selectedSigle.toLowerCase()) || equivalence.sigle.toLowerCase().includes(this.selectedSigle.toLowerCase()));
                    }
                }

                if (this.selectedName) {
                    if (this.selectedTypeFilter === 'externe') {
                        matches = matches && equivalence.titre.toLowerCase().includes(this.selectedName.toLowerCase());
                    } else {
                        matches = matches && (equivalence.titreEts.toLowerCase().includes(this.selectedName.toLowerCase()) || matches && equivalence.titre.toLowerCase().includes(this.selectedName.toLowerCase()));
                    }
                }

                return matches;

            });
// console.log('filteredEquivalences', equivalences);
            let institutions = [];
            // put equivalences under their institution
            equivalences.forEach(equivalence => {
                let institution = institutions.find(i => i.institutionId === equivalence.institutionId);
                if (!institution) {
                    institution = { name: equivalence.institution, equivalences: [], institutionId: equivalence.institutionId};
                    institutions.push(institution);
                }
                institution.equivalences.push(equivalence);
            });

            // sort institutions by name
            institutions.sort((a, b) => a.name.localeCompare(b.name));

            // sort equivalences by sigle
            institutions.forEach(institution => {
                institution.equivalences.sort((a, b) => a.sigle.localeCompare(b.sigle));
            });

            return institutions;
        },
        countFilteredEquivalence() {
            return this.filteredEquivalences.reduce((count, institution) => {
                return count + institution.equivalences.length;
            }, 0);
        },
        institutionOptions() {

            let setted = [];
            let institutions = [];
            this.equivalences.forEach(equivalence => {
                if (this.selectedTypeFilter === 'externe' && equivalence.institutionIsInternal) return;

                if (equivalence.institutionId && !setted.includes(equivalence.institutionId)) {
                    setted.push(equivalence.institutionId);
                    institutions.push({
                        value: equivalence.institutionId,
                        label: equivalence.institution,
                        isInternal: equivalence.institutionIsInternal
                    });
                }
            });


            institutions.sort((a, b) => a.label.localeCompare(b.label, 'fr'));

            if (this.selectedTypeFilter === 'externe') {
                institutions = institutions.filter(institution => institution.value !== 'ÉTS');
            }
            return institutions;
        }
        // Add any other computed properties here
    },
    methods: {
        t(string) {
            return EquivalenceLocalisation[string];
        },
        resetFilters() {
            this.selectedTypeFilter = 'externe';
            this.selectedInstitution = '';
            this.selectedSigle = '';
            this.selectedName = '';
        }
        ,
        showResultatSum() {
            if (!this.selectedInstitution && !this.selectedSigle && !this.selectedName) {
                return false;
            }
            return true;
        }
    }
};
</script>
